import {IWithSummaryModel} from '../../../../common/permission/api/entity/iWithSummary.model';
import {InsoleCadProcessSummaryModel} from './insoleCadProcessSummary.model';
import {InsolesSummaryModel} from '../../../insoles/api/model/insolesSummary.model';

export class InsoleCadProcessModel implements IWithSummaryModel<InsoleCadProcessSummaryModel> {
    summary: InsoleCadProcessSummaryModel;
    insoles: InsolesSummaryModel;
}
